/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Ask_QuestionsInputs */

const es_tools_nexata_ask_questions = /** @type {(inputs: Tools_Nexata_Ask_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando preguntas...`)
};

const en_tools_nexata_ask_questions = /** @type {(inputs: Tools_Nexata_Ask_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating questions...`)
};

/**
* | output |
* | --- |
* | "Generating questions..." |
*
* @param {Tools_Nexata_Ask_QuestionsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_ask_questions = /** @type {((inputs?: Tools_Nexata_Ask_QuestionsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Ask_QuestionsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_ask_questions(inputs)
	return en_tools_nexata_ask_questions(inputs)
});
export { tools_nexata_ask_questions as "tools.nexata.ask_questions" }